import * as React from 'react';

import { CatalogProductDetailViewFragmentFragment } from '@notino/shared/definitions/types';

import { usePriceConfig } from '@components/PriceLabel/usePriceConfig';

export const useSsrProductUrl = (
  product: CatalogProductDetailViewFragmentFragment
) => {
  const { data: { currentLocale } = {} } = usePriceConfig();

  const alternateSites = React.useMemo(
    () => product.alternateSites ?? [],
    [product.alternateSites]
  );

  const xDefault = React.useMemo(() => {
    const findByCulture = (culture: string) =>
      alternateSites.find((site) => site?.culture === culture);
    return (
      findByCulture('en-GB') || findByCulture('cs-CZ') || alternateSites[0]
    );
  }, [alternateSites]);

  const url = React.useMemo(
    () =>
      (
        alternateSites.find((site) => site?.culture === currentLocale?.tag) ||
        xDefault
      )?.link,
    [alternateSites, currentLocale, xDefault]
  );

  return { url, xDefault } as const;
};
